// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__wbOEv","inner":"Footer_inner__2mM5d","nextIcon":"Footer_nextIcon__mQ5J7","innerLeft":"Footer_innerLeft__1sjzS"};